import React from "react"
import { useNavigate } from "react-router-dom"

import HomeCard from "./components/card"
import ROUTES from "../../router/routesConstants"

import { useUserContext } from "../../context/usercontext"

import { Button } from "primereact/button"
import { ProgressSpinner } from "primereact/progressspinner"

function Home() {
  const { userData, loading } = useUserContext()
  const navigate = useNavigate()

  if (loading) {
    return (
      <div
        className="container flex align-items-center justify-content-center"
        style={{ height: "100vh" }}
      >
        <ProgressSpinner />
      </div>
    )
  }

  if (!userData || !userData.points) {
    return (
      <div
        className="container flex align-items-center justify-content-center"
        style={{ height: "100vh" }}
      >
        <ProgressSpinner />
      </div>
    )
  }

  return (
    <div>
      <div className="flex gap-2 align-items-start justify-content-center w-full mt-2 -mb-2">
        <p className="text-white text-xl m-0 font-bold">Hola</p>
        <p style={{ color: "#ffa400" }} className="text-xl mt-0 font-bold">
          {userData?.name_first || ""}
        </p>
      </div>
      <hr />

      <div className="flex flex-column">
        <div className="flex flex-column align-items">
          <h2 className="text-2xl text-center text-white font-bold mb-3">
            Tu tarjeta de puntos disponibles
          </h2>
        </div>
        <div className="flex flex-column justify-content-center align-items-center mb-6">
          <Button
            icon="pi pi-share-alt"
            label="Compartir Código"
            onClick={() => navigate(ROUTES.SHARE_CODE)}
          />
        </div>
        <HomeCard user={userData} />
      </div>
    </div>
  )
}

export default Home
